// extracted by mini-css-extract-plugin
export default {"animate":"Animate_animate__uGoGk","core":"Animate_core__HLBhz"};